import { gql } from 'graphql-request';

import {
  SelectedProductDownloadUrlsClassName,
  SelectedProductDownloadUrlsID,
  SelectedProductDownloadUrlsType,
  SelectedProductDownloadUrlsUrl,
  SelectedProductDownloadUrlsUUID,
  SelectedProductID,
  SelectedProductUUID
} from '../selectedProductsTypes';

export interface FetchSelectedProductDownloadUrlsQueryResponse {
  id: SelectedProductID;
  uuid: SelectedProductUUID;
  downloadUrls: {
    url: SelectedProductDownloadUrlsUrl;
    id: SelectedProductDownloadUrlsID;
    uuid: SelectedProductDownloadUrlsUUID;
    type: SelectedProductDownloadUrlsType;
    className: SelectedProductDownloadUrlsClassName;
  }[];
}

export const FETCH_SELECTED_PRODUCT_DOWNLOAD_URLS_QUERY = gql`
  query SelectedProductDownloadUrls($uuid: ID!) {
    selectedProduct(uuid: $uuid) {
      id
      uuid
      downloadUrls {
        className
        url
        id
        uuid
        type
      }
    }
  }
`;
